/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Double_Book_GuardInputs */

const en_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-book guard`)
};

const ar_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحماية من الحجز المزدوج`)
};

const bn_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডাবল-বুকিং সুরক্ষা`)
};

const de_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelbuchungsschutz`)
};

const es_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protección contra doble reserva`)
};

const fr_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garde contre les doubles réservations`)
};

const pt_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteção contra duplo agendamento`)
};

const zh_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防重复预订`)
};

const tr_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çifte rezervasyon koruması`)
};

const ru_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита от двойной записи`)
};

const pl_svchip_double_book_guard = /** @type {(inputs: Svchip_Double_Book_GuardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ochrona przed podwójną rezerwacją`)
};

/**
* | output |
* | --- |
* | "Double-book guard" |
*
* @param {Svchip_Double_Book_GuardInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_double_book_guard = /** @type {((inputs?: Svchip_Double_Book_GuardInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Double_Book_GuardInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_double_book_guard(inputs)
	if (locale === "bn") return bn_svchip_double_book_guard(inputs)
	if (locale === "de") return de_svchip_double_book_guard(inputs)
	if (locale === "es") return es_svchip_double_book_guard(inputs)
	if (locale === "fr") return fr_svchip_double_book_guard(inputs)
	if (locale === "pt") return pt_svchip_double_book_guard(inputs)
	if (locale === "zh") return zh_svchip_double_book_guard(inputs)
	if (locale === "tr") return tr_svchip_double_book_guard(inputs)
	if (locale === "ru") return ru_svchip_double_book_guard(inputs)
	if (locale === "pl") return pl_svchip_double_book_guard(inputs)
	return en_svchip_double_book_guard(inputs)
});